import React from "react";
import { Col, Row } from "react-bootstrap";
import Avatar from "components/common/Avatar";
import FalconLightBoxGallery from "components/common/FalconLightBoxGallery";

const FilesSection = ({ photos = [] }) => (
  <>
    <h6 className="fw-bold mb-2">Files</h6>
    {photos.length > 0 ? (
      <div>
        <label className="form-label text-xxs mb-2">Uploaded Photos</label>
        <FalconLightBoxGallery images={photos}>
          {(setImgIndex) => (
            <Row className="g-2">
              {photos.map((photo, index) => (
                <Col
                  sm={4}
                  md={6}
                  key={index}
                  onClick={() => setImgIndex(index)}
                  style={{ height: 120 }}
                >
                  <Avatar
                    rounded="square"
                    src={photo}
                    size="5xl"
                    className="h-100 w-100 cover rounded-2 overflow-hidden shadow-lg"
                  />
                </Col>
              ))}
            </Row>
          )}
        </FalconLightBoxGallery>
      </div>
    ) : (
      <p className="text-xs text-muted">No photos uploaded</p>
    )}
  </>
);

export default FilesSection;
